module.exports = __webpack_public_path__ + "img/212.e086dbb0.jpg";